export default "__VITE_ASSET__DEbNRn4A__"